export default __webpack_public_path__ + "static/media/line-left-fad.b6c9653b.svg";